// extracted by mini-css-extract-plugin
module.exports = {"callToAction":"styles_callToAction__fsbu_","icon":"styles_icon___s5q8","label":"styles_label__tmpqy"};